import { useEffect } from "react";
import styles from "./MainContent.module.scss";
import classNames from "classnames/bind";
import Invoice from "./tabs/invoices/Invoice";
import Payment from "./tabs/payments/Payment";
import BudgetTracker from "./tabs/budget-tracker/BudgetTracker";
import CreditMemo from "./tabs/credit-memo/CreditMemo";
import {
  ICreditMemoJobDetails,
  IInvoiceJobDetails,
  InvoiceDetailsAction,
  InvoiceFormSource,
} from "~/utils/interface/jobDetails";

const cx = classNames.bind(styles);

type CombinedSubTab = "invoice" | "payment" | "budget-tracker" | "credit-memo";

interface FinancialCombinedContentProps {
  jobId: string;
  handleCreateInvoice: (listInvoice: IInvoiceJobDetails[], source?: InvoiceFormSource) => void;
  getListInvoice: boolean;
  setGetListInvoice: (value: boolean) => void;
  handleViewDetails: (invoiceId: string, action?: InvoiceDetailsAction) => void;
  getListPayment: boolean;
  setGetListPayment: (value: boolean) => void;
  getListBudgetTracker: boolean;
  setGetListBudgetTracker: (value: boolean) => void;
  getListCreditMemo: boolean;
  setGetListCreditMemo: (value: boolean) => void;
  handleCreateBudgetTracker: (idBudget?: string, isEdit?: boolean) => void;
  handleViewDetailsBudget: (idBudget: string) => void;
  handleCreateCreditMemo: (listCreditMemo: ICreditMemoJobDetails[]) => void;
  defaultSubTab?: CombinedSubTab;
  onDefaultSubTabApplied?: () => void;
  onAddNote?: () => void;
  handleEditCreditMemo: (idCreditMemo: string) => void;
}

const FinancialCombinedContent = ({
  jobId,
  handleCreateInvoice,
  getListInvoice,
  setGetListInvoice,
  handleViewDetails,
  getListPayment,
  setGetListPayment,
  getListBudgetTracker,
  setGetListBudgetTracker,
  getListCreditMemo,
  setGetListCreditMemo,
  handleCreateBudgetTracker,
  handleViewDetailsBudget,
  handleCreateCreditMemo,
  defaultSubTab,
  onDefaultSubTabApplied,
  onAddNote,
  handleEditCreditMemo,
}: FinancialCombinedContentProps) => {
  useEffect(() => {
    if (defaultSubTab) {
      onDefaultSubTabApplied?.();
    }
  }, [defaultSubTab, onDefaultSubTabApplied]);

  return (
    <div className={cx("main-content-container")}>
      <div className={cx("content-area")}>
        <Invoice
          jobId={jobId}
          handleCreateInvoice={handleCreateInvoice}
          getListInvoice={getListInvoice}
          setGetListInvoice={setGetListInvoice}
          handleViewDetails={handleViewDetails}
        />
        <Payment
          jobId={jobId}
          getListPayment={getListPayment}
          setGetListPayment={setGetListPayment}
        />
        <BudgetTracker
          jobId={jobId}
          handleCreateBudgetTracker={handleCreateBudgetTracker}
          handleViewDetailsBudget={handleViewDetailsBudget}
          getListBudgetTracker={getListBudgetTracker}
          setGetListBudgetTracker={setGetListBudgetTracker}
          onAddNote={onAddNote}
        />
        <CreditMemo
          jobId={jobId}
          handleCreateCreditMemo={handleCreateCreditMemo}
          getListCreditMemo={getListCreditMemo}
          setGetListCreditMemo={setGetListCreditMemo}
          handleEditCreditMemo={handleEditCreditMemo}
        />
      </div>
    </div>
  );
};

export default FinancialCombinedContent;

